import { render, staticRenderFns } from "./CessionariaParamsModal.vue?vue&type=template&id=5827e0d4&lang=true"
import script from "./CessionariaParamsModal.vue?vue&type=script&lang=js"
export * from "./CessionariaParamsModal.vue?vue&type=script&lang=js"
import style0 from "./CessionariaParamsModal.vue?vue&type=style&index=0&id=5827e0d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports